<template>
  <div class="brief-answer">
    <el-input
      class="brief-answer-input"
      v-model="inputValue"
      placeholder="请输入..."
      type="textarea"
      maxlength="1000"
      show-word-limit
      :autosize="{ minRows: 15, maxRows: 50 }"
    ></el-input>
    <div class="btn" @click="answerChange">保存</div>
  </div>
</template>
<script setup>
import { defineExpose, ref, defineEmits } from "vue";
import { ElMessage } from "element-plus";
const inputValue = ref("");
const emit = defineEmits(["change"]);
const open = async (question, answer) => {
  inputValue.value = answer;
};
const answerChange = () => {
  emit("change", inputValue.value);
  ElMessage.success("保存成功");
};
defineExpose({ open });
</script>
<style scoped lang="less">
.brief-answer {
  .brief-answer-input {
    font-size: 20px;
    line-height: 2;
  }
  .btn {
    text-align: center;
    width: 90px;
    height: 36px;
    line-height: 36px;
    border-radius: 5px;
    color: #fff;
    background-color: #1c68ffff;
    border: 1px solid #1c68ffff;
    font-size: 14px;
    cursor: pointer;
    float: right;
    margin-top: 12px;
  }
}
</style>
